export const scrollAnchor = (router) => {
  const anchor = router.currentRoute.hash
  if (anchor && document.querySelector(anchor)) {
    setTimeout(() => {
      location.href = anchor
    }, 1)
  }
}
